import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getActionProgressState } from '../../../store/selectors/actionProgress';
import actionProgress from '../../../store/slices/actionProgress';

import ActionProgress from './ActionProgress';

const mapStateToProps = (state: AppState) => ({
  progress: getActionProgressState(state),
});

const mapDispatchToProps = {
  onCancel: actionProgress.cancel,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ActionProgressContainerProps = ConnectedProps<typeof connector>;

export default connector(ActionProgress);
